import { useEffect, useState } from "react";
import ApiCall from "../Apicall/ApiCall.js";

// The vehicle that is currently under one of this user's deals, with its full detail, or null.
//
// "Under a deal" is wider than "open deal": signing CLOSES the deal server-side, so a signed
// contract whose payment the seller has not confirmed yet is no longer an active contract — but
// the vehicle is still very much in the middle of that transaction, and the register must keep
// showing it. Before this, the record vanished the moment both parties signed, which with mock
// signing meant the page looked permanently empty.
//
// A cancelled or expired deal is not shown, and neither is a deal whose payment is settled: the
// owned-vehicle register that would then take over (inspection, insurance, registered owner) has
// no backend yet, so the page falls back to its empty state as before.
export default function useActiveDealVehicle() {
  const [state, setState] = useState({ loading: true, deal: null, userId: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const me = await ApiCall({ url: "/Session/GetCurrentLoginInformations", method: "GET" });
        const userId = me?.data?.result?.user?.id;
        if (!userId) throw new Error("no user");

        const activeRes = await ApiCall({
          url: "/ContractMain/GetActiveContractByUserId",
          method: "GET",
          params: { Id: userId },
        });
        const active = activeRes?.result || activeRes?.data?.result;

        let chosen = null;
        if (active?.id && (active.sellerUserId === userId || active.buyerDealConnected)) {
          chosen = active;
        } else {
          // No open deal: the vehicle may still be under a signed one that is awaiting payment.
          // Same lookup the overview uses, so the two surfaces always agree about which deal is
          // the user's current one.
          try {
            const pendingRes = await ApiCall({ url: "/ContractPayment/GetDealAwaitingPayment", method: "GET" });
            const pending = pendingRes?.data?.result || pendingRes?.result;
            if (pending?.contractId) chosen = { id: pending.contractId };
          } catch (_) {
            /* nothing pending: the empty register stands */
          }
        }

        if (!chosen) {
          if (!cancelled) setState({ loading: false, deal: null, userId });
          return;
        }

        let detail = chosen;
        try {
          const res = await ApiCall({ url: "/ContractMain/GetContractMainById", method: "GET", params: { Id: chosen.id } });
          detail = res?.result || res?.data?.result || chosen;
        } catch (_) {
          /* the active contract still carries the vehicle summary */
        }

        // sellerUserId also proves the detail really loaded: the payment fallback above starts
        // with nothing but an id, and a half-empty record is worse than the empty state.
        const live = Boolean(detail?.sellerUserId) && !detail.dealCancel && detail.dealState !== "expired";
        if (!cancelled) setState({ loading: false, deal: live ? { ...detail, fetchedAt: Date.now() } : null, userId });
      } catch (_) {
        if (!cancelled) setState({ loading: false, deal: null, userId: null });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
